import { lazy, type LazyExoticComponent } from 'react';

import type { ConversationAssistantUIProps } from './ConversationAssistantUI';
import { importConversationAssistantUI } from './import-conversation-assistant-ui';

/**
 * The chat UI behind a `lazy()` boundary, shared by `ConversationAssistantConfigurer` and
 * `ConversationAssistantConfigurerV2`.
 *
 * Neither configurer may import `ConversationAssistantUI` statically: they are both statically
 * imported by `ConversationAssistant.tsx`, so a static import would pull the UI graph into the
 * shared parent chunk and both arms of `rovo_chat_configurer_v2_split_out_ui` would download it —
 * leaving the experiment nothing to measure.
 */
export const ConversationAssistantUILazy: LazyExoticComponent<
	(props: ConversationAssistantUIProps) => React.JSX.Element
> = lazy(() =>
	importConversationAssistantUI().then((module) => ({
		default: module.ConversationAssistantUI,
	})),
);
